import { render, staticRenderFns } from "./TifCarguesTramasIndex.vue?vue&type=template&id=410e97f3"
import script from "./TifCarguesTramasIndex.vue?vue&type=script&lang=js"
export * from "./TifCarguesTramasIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports